<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card elevation="6">
            <v-card-title>
              <span>Head Pump Sizes ({{ count }}) </span>
              <v-spacer></v-spacer>
              <vs-button
                class="mx-2 text-caption"
                color="#6c5dd4"
                @click="createformdialog = true"
                >+ Add Head Pump Size</vs-button
              >
              <vs-button
                class="mx-2 text-caption"
                color="success"
                @click="exportToExcel"
                :loading="isExporting"
                >Export to Excel</vs-button
              >
            </v-card-title>
            <v-progress-linear
              v-if="isLoading"
              indeterminate
              color="primary"
            ></v-progress-linear>
            <v-simple-table
              fixed-header
              :height="$vuetify.breakpoint.smAndDown ? 'auto' : '600'"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Category</th>
                    <th class="text-left">Type</th>
                    <th class="text-left">Power</th>
                    <th class="text-left">Size</th>
                    <th class="text-left">LPD</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody v-if="headPumpSizes.length != 0">
                  <tr v-for="(headPumpSize, i) in headPumpSizes" :key="`headPumpSize${i}`">
                    <td style="min-width: 85px">
                      &nbsp;
                      {{ i + 1 }}
                    </td>
                    <td>{{ headPumpSize.category }}</td>
                    <td>{{ headPumpSize.type }}</td>
                    <td>{{ headPumpSize.power }}</td>
                    <td>{{ headPumpSize.size }}</td>
                    <td>{{ headPumpSize.lpd }}</td>
                    <td class="text-right">
                      <v-btn
                        class="mx-2"
                        fab
                        x-small
                        elevation="0"
                        color="#6c5dd4"
                        dark
                        @click="getHeadPumpSize(headPumpSize.id)"
                      >
                        <v-icon size="15"> mdi-pencil </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="7" class="text-center">No data found</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>

      <!-- create form -->
      <vs-dialog v-model="createformdialog" :loading="isLoading">
        <template #header>
          <h4 class="not-margin">
            Add <b>Head Pump Size</b>
          </h4>
        </template>
        <v-col cols="12" class="px-1">
          <label for="" class="text-caption">Category * </label>
          <v-autocomplete
            class="role-autocomplete"
            elevation="0"
            dense
            solo
            v-model="Createform.category"
            :items="pumpCategoriesFormatted"
            item-text="text"
            item-value="value"
            label="Select Category"
            :error-messages="errors && errors.category ? errors.category : ''"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" class="px-1">
          <label for="" class="text-caption">Type * </label>
          <v-autocomplete
            class="role-autocomplete"
            elevation="0"
            dense
            solo
            v-model="Createform.type"
            :items="[{text: 'DC', value: 'DC'}, {text: 'AC', value: 'AC'}]"
            item-text="text"
            item-value="value"
            label="Select Type"
            :error-messages="errors && errors.type ? errors.type : ''"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" class="px-1">
          <label for="" class="text-caption">Power * </label>
          <v-autocomplete
            class="role-autocomplete"
            elevation="0"
            dense
            solo
            v-model="Createform.power"
            :items="motorHPOptionsFormatted"
            item-text="text"
            item-value="value"
            label="Select Power"
            :error-messages="errors && errors.power ? errors.power : ''"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" class="px-1">
          <label for="" class="text-caption">Size </label>
          <vs-input
            primary
            v-model="Createform.size"
            type="number"
            placeholder="Enter size"
            icon-after
            block
          >
            <template #icon>
              <i class="mdi mdi-ruler"></i>
            </template>
            <template #message-danger>
              {{ errors && errors.size ? errors.size : "" }}
            </template>
          </vs-input>
        </v-col>
        <v-col cols="12" class="px-1">
          <label for="" class="text-caption">LPD </label>
          <vs-input
            primary
            v-model="Createform.lpd"
            type="number"
            placeholder="Enter LPD"
            icon-after
            block
          >
            <template #icon>
              <i class="mdi mdi-water"></i>
            </template>
            <template #message-danger>
              {{ errors && errors.lpd ? errors.lpd : "" }}
            </template>
          </vs-input>
        </v-col>
        <v-col cols="12">
          <vs-button
            class="float-end"
            :loading="isLoading"
            color="#6c5dd4"
            dark
            @click="save"
          >
            Save Head Pump Size
          </vs-button>
        </v-col>
      </vs-dialog>

      <!-- Edit form -->
      <vs-dialog v-model="editformdialog" :loading="isLoading">
        <template #header>
          <h4 class="not-margin">
            Edit <b>Head Pump Size</b>
          </h4>
        </template>
        <v-col cols="12" class="px-1">
          <label for="" class="text-caption">Category * </label>
          <v-autocomplete
            class="role-autocomplete"
            elevation="0"
            dense
            solo
            v-model="Editform.category"
            :items="pumpCategoriesFormatted"
            item-text="text"
            item-value="value"
            label="Select Category"
            :error-messages="errors && errors.category ? errors.category : ''"
            :key="'edit-category-' + editformdialog"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" class="px-1">
          <label for="" class="text-caption">Type * </label>
          <v-autocomplete
            class="role-autocomplete"
            elevation="0"
            dense
            solo
            v-model="Editform.type"
            :items="[{text: 'DC', value: 'DC'}, {text: 'AC', value: 'AC'}]"
            item-text="text"
            item-value="value"
            label="Select Type"
            :error-messages="errors && errors.type ? errors.type : ''"
            :key="'edit-type-' + editformdialog"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" class="px-1">
          <label for="" class="text-caption">Power * </label>
          <v-autocomplete
            class="role-autocomplete"
            elevation="0"
            dense
            solo
            v-model="Editform.power"
            :items="motorHPOptionsFormatted"
            item-text="text"
            item-value="value"
            label="Select Power"
            :error-messages="errors && errors.power ? errors.power : ''"
            :key="'edit-power-' + editformdialog"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" class="px-1">
          <label for="" class="text-caption">Size </label>
          <vs-input
            primary
            v-model="Editform.size"
            type="number"
            placeholder="Enter size"
            icon-after
            block
          >
            <template #icon>
              <i class="mdi mdi-ruler"></i>
            </template>
            <template #message-danger>
              {{ errors && errors.size ? errors.size : "" }}
            </template>
          </vs-input>
        </v-col>
        <v-col cols="12" class="px-1">
          <label for="" class="text-caption">LPD </label>
          <vs-input
            primary
            v-model="Editform.lpd"
            type="number"
            placeholder="Enter LPD"
            icon-after
            block
          >
            <template #icon>
              <i class="mdi mdi-water"></i>
            </template>
            <template #message-danger>
              {{ errors && errors.lpd ? errors.lpd : "" }}
            </template>
          </vs-input>
        </v-col>
        <v-col cols="12">
          <vs-button
            class="float-end"
            :loading="isLoading"
            color="#6c5dd4"
            dark
            @click="update(Editform.id)"
          >
            Update Head Pump Size
          </vs-button>
        </v-col>
      </vs-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "HeadPumpSizesPage",
  data() {
    return {
      count: 0,
      isLoading: false,
      isExporting: false,
      createformdialog: false,
      editformdialog: false,
      Createform: {
        category: "",
        type: "",
        power: "",
        size: null,
        lpd: null,
      },
      Editform: {
        category: "",
        type: "",
        power: "",
        size: null,
        lpd: null,
      },
      headPumpSizes: [],
      pumpCategories: [],
      pumpCategoriesFormatted: [],
      motorHPOptions: [],
      motorHPOptionsFormatted: [],
      errors: {},
    };
  },
  mounted() {
    this.getData();
    this.getPumpCategories();
    this.getMotorHPOptions();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        let response = await axios.get(`/head_pump_sizes`);
        this.headPumpSizes = response.data.data;
        this.count = response.data.count;
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.error(e);
      }
    },
    async save() {
      try {
        this.isLoading = true;
        this.errors = {};
        await axios.post("/head_pump_sizes", this.Createform);
        this.isLoading = false;
        this.createformdialog = false;
        this.Createform = {};
        this.getData();
        this.$vs.notification({
          title: "Success",
          text: "Head Pump Size created successfully",
          color: "success",
        });
      } catch (e) {
        this.isLoading = false;
        if (e.response && e.response.data && e.response.data.errors) {
          this.errors = e.response.data.errors;
        }
        this.$vs.notification({
          title: "Error",
          text: "Failed to create Head Pump Size",
          color: "danger",
        });
      }
    },
    async getHeadPumpSize(headPumpSizeId) {
      // Reset form first
      this.Editform = {
        category: "",
        type: "",
        power: "",
        size: null,
        lpd: null,
      };
      this.errors = {};
      this.isLoading = true;
      
      try {
        // Ensure dropdown options are loaded before opening dialog
        if (this.pumpCategoriesFormatted.length === 0) {
          await this.getPumpCategories();
        }
        if (this.motorHPOptionsFormatted.length === 0) {
          await this.getMotorHPOptions();
        }
        
        let response = await axios.get(`/head_pump_sizes/${headPumpSizeId}`);
        console.log('=== EDIT DEBUG START ===');
        console.log('API Response data:', response.data.data);
        console.log('Category from API:', response.data.data.category);
        console.log('Power from API:', response.data.data.power);
        console.log('Size from API:', response.data.data.size);
        console.log('LPD from API:', response.data.data.lpd);
        console.log('Available categories:', this.pumpCategoriesFormatted);
        console.log('Available power options:', this.motorHPOptionsFormatted);
        
        // Wait for next tick to ensure dropdown options are rendered
        await this.$nextTick();
        
        // Set form values directly with strings (not objects)
        // v-autocomplete will match these strings to the dropdown options
        this.$set(this.Editform, 'category', response.data.data.category || '');
        this.$set(this.Editform, 'type', response.data.data.type || '');
        this.$set(this.Editform, 'power', response.data.data.power || '');
        this.$set(this.Editform, 'size', response.data.data.size || null);
        this.$set(this.Editform, 'lpd', response.data.data.lpd || null);
        this.Editform.id = headPumpSizeId;
        
        console.log('Form after setting values:', this.Editform);
        console.log('=== EDIT DEBUG END ===');
        
        console.log('Form data set to:', this.Editform);
        console.log('Looking for category match:', response.data.data.category);
        console.log('Looking for power match:', response.data.data.power);
        
        // Open dialog after another tick
        await this.$nextTick();
        this.editformdialog = true;
        this.isLoading = false;
        
      } catch (e) {
        this.isLoading = false;
        console.error(e);
      }
    },
    async update(headPumpSizeId) {
      try {
        this.isLoading = true;
        this.errors = {};
        await axios.patch(`/head_pump_sizes/${headPumpSizeId}`, this.Editform);
        this.isLoading = false;
        this.editformdialog = false;
        this.getData();
        this.$vs.notification({
          title: "Success",
          text: "Head Pump Size updated successfully",
          color: "success",
        });
      } catch (e) {
        this.isLoading = false;
        if (e.response && e.response.data && e.response.data.errors) {
          this.errors = e.response.data.errors;
        }
        this.$vs.notification({
          title: "Error",
          text: "Failed to update Head Pump Size",
          color: "danger",
        });
      }
    },
    async getPumpCategories() {
      try {
        let response = await axios.get(`/head_pump_sizes/pump_categories`);
        this.pumpCategories = response.data.data;
        
        // Format for v-autocomplete
        this.pumpCategoriesFormatted = [];
        this.pumpCategories.forEach((category) => {
          this.pumpCategoriesFormatted.push({
            id: category.id,
            text: category.description,
            value: category.description,
          });
        });
      } catch (e) {
        console.error('Error fetching pump categories:', e);
        this.$vs.notification({
          title: "Error",
          text: "Failed to load pump categories",
          color: "danger",
        });
      }
    },
    async getMotorHPOptions() {
      try {
        let response = await axios.get(`/head_pump_sizes/motor_hp`);
        this.motorHPOptions = response.data.data;
        
        // Format for v-autocomplete
        this.motorHPOptionsFormatted = [];
        this.motorHPOptions.forEach((power) => {
          this.motorHPOptionsFormatted.push({
            id: power.id,
            text: power.description,
            value: power.description,
          });
        });
      } catch (e) {
        console.error('Error fetching motor HP options:', e);
        this.$vs.notification({
          title: "Error",
          text: "Failed to load motor HP options",
          color: "danger",
        });
      }
    },
    async exportToExcel() {
      try {
        this.isExporting = true;
        const response = await axios.get('/head_pump_sizes/export', {
          responseType: 'blob',
        });
        
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        
        // Extract filename from response headers or use default
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'head_pump_sizes_export.xlsx';
        if (contentDisposition) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
          }
        }
        
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        
        this.$vs.notification({
          title: "Success",
          text: "Excel export completed successfully",
          color: "success",
        });
      } catch (e) {
        console.error('Export error:', e);
        this.$vs.notification({
          title: "Error",
          text: "Failed to export Excel file",
          color: "danger",
        });
      } finally {
        this.isExporting = false;
      }
    },
  },
};
</script>

<style scoped>
.role-autocomplete .v-input__slot {
  box-shadow: none !important;
  background: #f4f7f8 !important;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
  border-radius: 10px;
}
</style>